import React from 'react';
import CommentItem from './CommentItem';
import ReplyList from './ReplyList';

const CommentList = ({
  comments,
  sortBy,
  onSortChange,
  isLoading,
  hasMore,
  onLoadMore,
  onCommentUpdate,
  onCommentDelete,
  onReplyAdded
}) => {
  return (
    <div className="space-y-6">
      {/* Sorting Dropdown */}
      {comments.length > 0 && (
        <div className="flex items-center justify-end">
          <div className="flex items-center space-x-2">
            <label className="text-gray-500 text-sm">Sort by:</label>
            <select
              value={sortBy}
              onChange={(e) => onSortChange(e.target.value)}
              className="bg-battle-dark text-white border border-army/40 rounded-lg px-3 py-1.5 text-sm focus:border-brand-yellow/60 focus:outline-none focus:ring-1 focus:ring-brand-yellow/20 transition-all cursor-pointer"
            >
              <option value="newest">Newest first</option>
              <option value="oldest">Oldest first</option>
              <option value="popular">Most popular</option>
            </select>
          </div>
        </div>
      )}

      {/* Comments */}
      {isLoading && comments.length === 0 ? (
        <div className="text-center py-12">
          {/* battle-red kept: live activity spinner = semantic */}
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-battle-red"></div>
          <p className="text-gray-500 mt-4">Loading comments...</p>
        </div>
      ) : comments.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500">No comments yet. Be the first to drop a take!</p>
        </div>
      ) : (
        <div className="space-y-4">
          {comments.map(comment => (
            <div key={comment.id}>
              <CommentItem
                comment={comment}
                onUpdate={onCommentUpdate}
                onDelete={onCommentDelete}
                onReply={onReplyAdded}
                showReplyButton={true}
              />
              {comment.replies_count > 0 && (
                <ReplyList
                  parentComment={comment}
                  initialReplies={comment.replies || []}
                />
              )}
            </div>
          ))}

          {/* Load More Button */}
          {hasMore && (
            <div className="text-center pt-4">
              <button
                onClick={onLoadMore}
                disabled={isLoading}
                className="btn-secondary text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading ? (
                  <span className="flex items-center space-x-2">
                    <div className="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    <span>Loading...</span>
                  </span>
                ) : (
                  'Load more comments'
                )}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CommentList;
